export const SET_ALERT_SHOWN = "SET_ALERT_SHOWN";
export const SET_ALERT_INFO = "SET_ALERT_INFO";

export const SET_PROMPT_SHOWN = "SET_PROMPT_SHOWN";
export const SET_PROMPT_INFO = "SET_PROMPT_INFO";
